import {
  put, call, take, fork,
  takeLatest, takeEvery,
} from 'redux-saga/effects';
import { eventChannel } from 'redux-saga';
import EventEmitter from 'events';

import AppFlowActions from '../../constants';
import { memorizeMachines } from '../../utils/memorize';
import { trackAdded, trackRemoved } from '../Actions/machine';
import jitsiInstance, { JitsiConferenceEvents } from '../../utils/jitsi';
import jitsiConfig from '../../utils/jitsi/config';
import { RemoteControl } from '../../remoteControlContants';
import { fetchAllMachine } from '../Helpers/fetch';

function fetch(serialMachine) {
  try {
    return fetchAMachine(serialMachine);
  } catch (error) {
    return null;
  }
}

function fetchAll() {
  try {
    return fetchAllMachine();
  } catch (error) {
    return null;
  }
}


function* allMachineListFlow() {
  const INFINITE = true;
  while (INFINITE) {
    yield take(AppFlowActions.GET_ALL_MACHINE_REQUEST);

    const machines = yield call(fetchAll);
    console.log('all machine ', machines);
    if (machines) {
      yield put({ type: AppFlowActions.GET_ALL_MACHINE_COMPLETE, machines: memorizeMachines(machines) });
    }

    // yield put({ type: AppFlowActions.LOADING_COMPLETE, isLoading: false });
  }
}

function* aMachineListFlow() {
  const INFINITE = true;
  while (INFINITE) {
    const request = yield take(AppFlowActions.GET_A_MACHINE_REQUEST);
    const { serialMachine } = request;

    const machine = yield call(fetch, serialMachine);

    console.log('a machine ', machine);
    if (machine) {
      yield put({ type: AppFlowActions.GET_A_MACHINE_COMPLETE, machine });
    }

    // yield put({ type: AppFlowActions.LOADING_COMPLETE, isLoading: false });
  }
}

function* setConfig(config) {
  yield call(jitsiInstance.initLib, config);
}

function startConferenceSubscriber() {
  const unsubscribe = () => {
    jitsiInstance.disconnect();
  };
  const eventEmitter = new EventEmitter();

  return eventChannel(emit => {
    jitsiInstance.connect(eventEmitter);

    eventEmitter.on(JitsiConferenceEvents.TRACK_ADDED, payload => {
      emit(trackAdded(payload));
    });

    eventEmitter.on(JitsiConferenceEvents.TRACK_REMOVED, payload => {
      emit(trackRemoved(payload));
    });

    return unsubscribe;
  });
}

export function* startConference({ room }) {
  try {
    yield setConfig(jitsiConfig);
    if (jitsiInstance.roomName) {
      jitsiInstance.unload();
    }
    yield call(jitsiInstance.setRoomName, room);
    const channel = yield call(startConferenceSubscriber);

    yield takeEvery(channel, function* s(value) {
      yield put(value);
    });
    yield localStorage.setItem(`isInitStream_${RemoteControl.PROJECT_ID}`, true);
  } catch (error) {
    console.log('startConference error', error);
  }
}

export function* stopConference() {
  try {
    yield call(jitsiInstance.unload);
  } catch (error) {
    console.log('stopConference error', error);
  }
}

export default function* machineFlow() {
  yield fork(allMachineListFlow);
  yield fork(aMachineListFlow);

  yield takeLatest(AppFlowActions.START_CONFERENCE, startConference);
  yield takeLatest(AppFlowActions.STOP_CONFERENCE, stopConference);
}
